import { gql } from '../__generated__/index.js';

//language=graphql
export const leaveGroup = gql(`
    mutation leaveGroup($groupId: ID!) {
        leaveGroup(groupId: $groupId)
    }
`);
